module.exports = __webpack_public_path__ + "static/media/p0102.03983682.jpg";